export enum LogisticContractStatus {
  Unknown = 'Unknown',
  Ok = 'Ok',
  Error = 'Error',
}
